module.exports = __webpack_public_path__ + "static/WEDDING E&M-527-92d7d09f3dd6d87eaec675642d9e2d1f.jpg";